import { render, staticRenderFns } from "./ReleaseGateComponent.vue?vue&type=template&id=483dc481&scoped=true&"
import script from "./ReleaseGateComponent.vue?vue&type=script&lang=js&"
export * from "./ReleaseGateComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseGateComponent.vue?vue&type=style&index=0&id=483dc481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483dc481",
  null
  
)

export default component.exports